// extracted by mini-css-extract-plugin
export default {"wrapper":"ApartmentsChoiceStep_wrapper__S1Gcj"};